"use client"
import { Component } from "react"
import moment from "moment"
import API, { URL_PATH } from "../../services/API"
import { base_url } from "../../services/API"
import React, { useState } from "react"
import FullscreenIcon from "@mui/icons-material/Fullscreen"
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit"
import ClearAllIcon from "@mui/icons-material/ClearAll"
import redux from "../../common/Redux"
import { initSocket } from "../../services/socket"
import { Tooltip } from "@mui/material"
import Text from "../../components/Text"
import { Box, Button } from "@mui/material"
import Header from "../../components/Header"
import noKotImage from "../../assets/Clip path group.svg"
import RefreshIcon from "@material-ui/icons/Refresh"
import Toast from "../../components/Toast"
import AutoPrintKOT from "../../components/AutoPrintKOT"
import ConfirmationModal from "../../components/ConfirmationModal"

const KotHeaderItemBox = ({ title, value, color, tooltip = false, style = {}, valueStyle = {} }) => {
  const locstyles = {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    margin: "0px 4px",
  }
  const mergeSTyles = { ...locstyles, ...style }
  const [previewOpen, setPreviewOpen] = useState(false)

  return (
    <Box sx={mergeSTyles}>
      <Text color={color} h9 regular>
        {title}
      </Text>
      <Tooltip title={tooltip}>
        <Text regular h6 color={color} style={valueStyle}>
          {value}
        </Text>
      </Tooltip>
    </Box>
  )
}

class ListMenuScreen extends Component {
  socket = null

  constructor(props) {
    super(props)
    this.state = {
      kotData: {
        pending: [],
        cooking: [],
        served: [],
      },
      orderTypes: [],
      selectedOrderType: "all",
      mode: "blocks",
      previewOpen: false,
      currentKotItem: null,
      kotItemToDelete: null,
      plandata: [],
      activeFeatures: [],
      currentPlan: null,
      activePlan: null,
      isPlanActive: false,
      activeMenuIndex: 0,
      isFullScreen: false,
      auto_kot_print: null,
      printedKotIds: [],
      auto_bill_print: false,
      isDeleteConfirmationModalOpen: false,
      itemToDelete: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
    this.timeouts = {}
    this.pageRef = React.createRef()
    this.autoPrintRef = React.createRef()
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  getConfigData = async () => {
    const response = await API(this, "get", URL_PATH.GET_PREFERENCES)
    const { status, message, data } = response
    if (status === "success") {
      const { hotelConfig } = data
      this.setState({
        auto_kot_print: hotelConfig.auto_kot_print,
        auto_bill_print: hotelConfig.auto_kot_print,
      })
    }
  }

  getData = async () => {
    try {
      const response = await API(this, "get", URL_PATH.subscriptionPlans)
      const { status, data, message, currentPlan = null, isPlanActive } = response
      if (status === "success") {
        let activePlan = null
        let activeFeatures = []
        if (currentPlan && currentPlan.plan_id) {
          activePlan = data.find((plan) => plan.id === currentPlan.plan_id)
          if (activePlan) {
            activeFeatures = activePlan.features || []
            activePlan = {
              ...activePlan,
              subscription_id: currentPlan.id,
              starts_at: currentPlan.starts_at,
              ends_at: currentPlan.ends_at,
              trial_ends_at: currentPlan.trial_ends_at,
              payment_method: currentPlan.payment_method,
            }
          }
        }
        this.setState({
          status,
          plandata: data,
          activeFeatures,
          currentPlan,
          activePlan,
          isPlanActive,
        })
      } else {
        this.showToast(message, "success")
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      this.showToast("Error fetching data", "error")
    }
  }

  handleAutoPrint = (kotData) => {
    try {
      console.log("🖨️ Auto printing KOT:", kotData)
      const printWindow = window.open("", "PRINT", "height=600,width=400")
      printWindow.document.write(`
        <html>
          <head>
            <title>KOT Print</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 10px;
                  font-family: monospace;
                  font-size: 10px;
                  width: 58mm;
                }
              }
              body {
                margin: 0;
                padding: 10px;
                font-family: monospace;
                font-size: 10px;
                width: 58mm;
              }
              .kot-header-row {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                gap: 10px;
                margin-bottom: 5px;
              }
              .kot-header-row > div {
                font-size: 10px;
              }
              .kot-customer-row {
                display: flex;
                justify-content: space-between;
                margin-top: 5px;
                margin-bottom: 5px;
                font-weight: bold;
                font-size: 10px;
                border-top: 1px dashed black;
                border-bottom: 1px dashed black;
                padding: 5px 0;
              }
              .kot-items table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 5px;
              }
              .kot-items td {
                padding: 2px 0;
                font-size: 10px;
              }
              .kot-item-quantity {
                font-weight: bold;
              }
              .kot-note {
                margin-top: 5px;
                font-style: italic;
                font-size: 10px;
              }
              .kot-footer {
                text-align: center;
                margin-top: 10px;
                font-size: 8px;
              }
            </style>
          </head>
          <body>
            ${this.createBlackAndWhiteKOT(kotData)}
          </body>
        </html>
      `)
      printWindow.document.close()
      printWindow.focus()
      setTimeout(() => {
        printWindow.print()
        printWindow.close()
      }, 500)
    } catch (err) {
      console.error("❌ Failed to auto-print:", err)
    }
  }

  componentDidMount() {
    this.fetchData().then(() => {
      this.subscribeToSocketIOChannels()
    })
    this.fetchreview()
    this.getData()
    this.getConfigData()
    document.addEventListener("fullscreenchange", this.handleFullScreenChange)
    document.addEventListener("webkitfullscreenchange", this.handleFullScreenChange)
    document.addEventListener("mozfullscreenchange", this.handleFullScreenChange)
    document.addEventListener("MSFullscreenChange", this.handleFullScreenChange)
  }

  closePreview = () => {
    this.setState({ previewOpen: false, currentKotItem: null })
  }

  showPreview = (item) => {
    this.setState({ previewOpen: true, currentKotItem: item })
  }

  subscribeToSocketIOChannels = () => {
    try {
      const hotelId = String(this.props.selectedHotelId.id)
      this.socket = initSocket(hotelId)

      // Remove hotel-level listeners to avoid duplicates
      this.socket.off(`etable_database_hotel.kot.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_user.order_status_updated.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_hotel.menu_update.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_hotel.table_update.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_hotel.kitchen_status.${hotelId}:hotel-events`)
      this.socket.off("connect")
      this.socket.off("disconnect")
      this.socket.off("reconnect")

      // Connection status events
      this.socket.on("connect", () => {
        console.log("✅ Socket.IO connected successfully")
        // this.showToast("Connected to real-time updates", "success")
      })

      this.socket.on("disconnect", (reason) => {
        console.log("❌ Socket.IO disconnected:", reason)
        // this.showToast("Disconnected from real-time updates", "warning")
      })

      this.socket.on("reconnect", (attemptNumber) => {
        console.log("🔄 Socket.IO reconnected after", attemptNumber, "attempts")
        this.showToast("Reconnected to real-time updates", "success")
        this.fetchData()
      })

      // KOT Events
      this.socket.on(`etable_database_hotel.kot.${hotelId}:hotel-events`, (data) => {
        console.log("📡 KOT Event Received:", data)
        try {
          const eventType = data?.data?.event
          if (eventType === "kot") {
            this.fetchData(true)
            if (this.autoPrintRef?.current && this.state.auto_kot_print && data.type === "new_kot") {
              this.autoPrintRef.current.handleAutoPrint(data.data)
            }
          } else if (eventType === "kot_status_update") {
            this.handleKOTStatusUpdate(data.data)
          } else if (eventType === "kot_item_update") {
            this.handleKOTItemUpdate(data.data)
          } else if (eventType === "kot_deleted") {
            this.handleKOTDeletion(data.data)
          }
        } catch (error) {
          console.error("❌ Error processing KOT event:", error)
          this.showToast("Error processing KOT update", "error")
        }
      })

      // 🔄 Subscribe to per-order status updates
      const kotData = this.state.kotData
      const allOrders = [
        ...(kotData.pending || []),
        ...(kotData.cooking || []),
        ...(kotData.served || [])
      ]


      allOrders.forEach((order) => {
        console.log("orderorderorder", order)
        const orderId = order.hotel_order_id

        if (orderId) {
          const eventName = `etable_database_user.order_status_updated.${orderId}:hotel-events`
          this.socket.off(eventName) // Clear previous
          this.socket.on(eventName, (data) => {
            console.log("📡 Order Status Updated (per order):", data)
            this.handleOrderStatusUpdate(data)
          })
        }
      })

      // Menu Update Events
      this.socket.on(`etable_database_hotel.menu_update.${hotelId}:hotel-events`, (data) => {
        console.log("📡 Menu Update Event:", data)
        this.fetchData()
      })

      // Table Update Events
      this.socket.on(`etable_database_hotel.table_update.${hotelId}:hotel-events`, (data) => {
        console.log("📡 Table Update Event:", data)
        this.handleTableUpdate(data)
      })

      // Kitchen Status Events
      this.socket.on(`etable_database_hotel.kitchen_status.${hotelId}:hotel-events`, (data) => {
        console.log("📡 Kitchen Status Event:", data)
        if (data.status === "offline") {
          this.showToast("Kitchen system is offline", "warning")
        } else if (data.status === "online") {
          this.showToast("Kitchen system is back online", "success")
        }
      })
    } catch (error) {
      console.error("❌ Error in subscribeToSocketIOChannels:", error)
      this.showToast("Failed to connect to real-time updates", "error")
    }
  }

  // Handle KOT status updates in real-time
  handleKOTStatusUpdate = (data) => {
    const { kot_id, status, updated_at } = data

    this.setState((prevState) => {
      const newKotData = { ...prevState.kotData }

      // Find the KOT in any of the arrays
      let kotItem = null
      let sourceArray = null

      if (newKotData.pending.find((kot) => kot.id === kot_id)) {
        kotItem = newKotData.pending.find((kot) => kot.id === kot_id)
        sourceArray = "pending"
      } else if (newKotData.cooking.find((kot) => kot.id === kot_id)) {
        kotItem = newKotData.cooking.find((kot) => kot.id === kot_id)
        sourceArray = "cooking"
      } else if (newKotData.served.find((kot) => kot.id === kot_id)) {
        kotItem = newKotData.served.find((kot) => kot.id === kot_id)
        sourceArray = "served"
      }

      if (kotItem && sourceArray) {
        // Remove from current array
        newKotData[sourceArray] = newKotData[sourceArray].filter((kot) => kot.id !== kot_id)

        // Update the item and add to new array
        const updatedKot = { ...kotItem, status, updated_at }
        newKotData[status].push(updatedKot)

        // Show toast notification
        this.showToast(`KOT #${kot_id} moved to ${status}`, "info")
      }

      return { kotData: newKotData }
    })
  }
  componentWillUnmount() {
    // Clean up Socket.IO listeners
    if (this.socket) {
      const hotelId = String(this.props.selectedHotelId.id)
      this.socket.off(`etable_database_hotel.kot.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_user.order_status_updated.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_hotel.menu_update.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_hotel.table_update.${hotelId}:hotel-events`)
      this.socket.off(`etable_database_hotel.kitchen_status.${hotelId}:hotel-events`)
      this.socket.off("connect")
      this.socket.off("disconnect")
      this.socket.off("reconnect")

      // Only disconnect if this is the last component using the socket
      // The socket service should handle this automatically
    }

    // Clean up other event listeners
    document.removeEventListener("fullscreenchange", this.handleFullScreenChange)
    document.removeEventListener("webkitfullscreenchange", this.handleFullScreenChange)
    document.removeEventListener("mozfullscreenchange", this.handleFullScreenChange)
    document.removeEventListener("MSFullscreenChange", this.handleFullScreenChange)

    // Clear timeouts
    Object.values(this.timeouts).forEach(clearTimeout)
  }

  // Handle individual KOT item updates
  handleKOTItemUpdate = (data) => {
    const { kot_id, item_id, served_or_not } = data

    this.setState((prevState) => {
      const newKotData = { ...prevState.kotData }

      // Find and update the specific KOT item
      Object.keys(newKotData).forEach((status) => {
        const kotIndex = newKotData[status].findIndex((kot) => kot.id === kot_id)
        if (kotIndex !== -1) {
          const itemIndex = newKotData[status][kotIndex].kot_items.findIndex((item) => item.id === item_id)
          if (itemIndex !== -1) {
            newKotData[status][kotIndex].kot_items[itemIndex].served_or_not = served_or_not
          }
        }
      })

      return { kotData: newKotData }
    })
  }

  // Handle KOT deletion
  handleKOTDeletion = (data) => {
    const { kot_id } = data

    this.setState((prevState) => {
      const newKotData = { ...prevState.kotData }

      // Remove from all arrays
      newKotData.pending = newKotData.pending.filter((kot) => kot.id !== kot_id)
      newKotData.cooking = newKotData.cooking.filter((kot) => kot.id !== kot_id)
      newKotData.served = newKotData.served.filter((kot) => kot.id !== kot_id)

      return { kotData: newKotData }
    })

    this.showToast(`KOT #${kot_id} has been deleted`, "info")
  }

  // Handle order status updates
  handleOrderStatusUpdate = (data) => {
    console.log("Handling order status update:", data)
    // Refresh data to get latest order status
    this.fetchData()
  }

  // Handle table updates
  handleTableUpdate = (data) => {
    console.log("Handling table update:", data)
    // Refresh data if table assignments change
    this.fetchData()
  }



  fetchreview = async () => {
    var { status, message, data } = await API(this, "get", URL_PATH.reviews(), {}, {})
    console.log("Review Data", data)
  }

  fetchData = async (isRealTimeUpdate = false) => {
    try {
      const { status, message, data, kot_print_status } = await API(
        this,
        "get",
        URL_PATH.listKOTV2(this.props.selectedHotelId.id),
      )

      if (status === "success") {
        let pendingKots = []
        let cookingKots = []
        let servedKots = []
        const orderTypes = ["all"]

        if (data) {
          Object.keys(data).forEach((orderType) => {
            if (!orderTypes.includes(orderType)) {
              orderTypes.push(orderType)
            }
            if (data[orderType]?.pending) {
              pendingKots = [...pendingKots, ...data[orderType].pending]
            }
            if (data[orderType]?.cooking) {
              cookingKots = [...cookingKots, ...data[orderType].cooking]
            }
            if (data[orderType]?.served) {
              servedKots = [...servedKots, ...data[orderType].served]
            }
          })
        }

        this.setState({
          kotData: {
            pending: pendingKots,
            cooking: cookingKots,
            served: servedKots,
          },
          orderTypes,
          auto_kot_print: kot_print_status || this.state.auto_kot_print,
        })

        if (isRealTimeUpdate) {
          console.log("📊 Data refreshed via real-time update")
        }
      } else {
        console.log("⚠️ Error fetching KOT list")
        this.showToast(message, "error")
      }
    } catch (error) {
      console.error("❌ fetchData failed:", error)
      this.showToast("Failed to fetch KOT data", "error")
    }
  }

  handleOrderTypeChange = (orderType) => {
    this.setState({ selectedOrderType: orderType })
  }

  getFilteredKotData = () => {
    const { kotData, selectedOrderType } = this.state
    if (selectedOrderType === "all") {
      return kotData
    }
    return {
      pending: kotData.pending.filter((kot) => kot.hotel_order?.order_type === selectedOrderType),
      cooking: kotData.cooking.filter((kot) => kot.hotel_order?.order_type === selectedOrderType),
      served: kotData.served.filter((kot) => kot.hotel_order?.order_type === selectedOrderType),
    }
  }

  handleSmallButtonClick = async () => {
    const { status, message, data } = await API(this, "post", URL_PATH.serveall(this.props.selectedHotelId.id))
    console.log("response", status, message, data)
    if (status === true) {
      this.showToast(message, "success")
      this.fetchData()
    } else {
      this.showToast(message, "error")
    }
  }

  changeKOTStatus = async (item, status) => {
    console.log("changeKOTStatus: ", item, status)
    const {
      status: status1,
      message,
      data,
    } = await API(this, "get", URL_PATH.updateKOTStatus, {
      kot_id: item.id,
      status: status,
    })

    if (status1 != "success") {
      return this.showToast(message, "error")
    }

    // The real-time update will handle the UI update
    // But we can also update locally for immediate feedback
    this.setState((prevState) => {
      const newKotData = { ...prevState.kotData }
      newKotData.pending = newKotData.pending.filter((kot) => kot.id !== item.id)
      newKotData.cooking = newKotData.cooking.filter((kot) => kot.id !== item.id)
      newKotData.served = newKotData.served.filter((kot) => kot.id !== item.id)

      if (status === "pending") {
        newKotData.pending.push({ ...item, status })
      } else if (status === "cooking") {
        newKotData.cooking.push({ ...item, status })
      } else if (status === "served") {
        newKotData.served.push({ ...item, status })
        this.timeouts[item.id] = setTimeout(() => {
          delete this.timeouts[item.id]
        }, 5000)
      }

      return { kotData: newKotData }
    })
  }

  handlekot = () => {
    this.setState({
      activeMenuIndex: -1,
      activeshortCutTopMenuIndex: 0,
    })
    this.props.history.push("/dine-in")
  }

createBlackAndWhiteKOT = (item) => {
  return `
    <div style="padding: 10px; font-family: Arial, sans-serif; max-width: 80mm;">
      <!-- KOT Header -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; border-bottom: 2px solid #000; padding-bottom: 5px;">
        <div style="font-size: 18px; font-weight: bold;">KOT #${item.id}</div>
        <div style="text-align:right">
          <div style="font-size: 16px; font-weight: bold;">ORDER ID : ${item.hotel_order_id}</div>
        </div>
      </div>
      <!-- Order Info -->
      <div style="display: flex; justify-content: space-between; margin-top:2px">
           ${item.hotel_order?.order_type === "dinein"
            ? `
              <div>
                <div style="font-size: 12px; color: #555;">TYPE</div>
                <div style="font-size: 16px; font-weight: bold; text-transform: uppercase;">
                  DINE-IN
                </div>
              </div>
             `
            : ""
          }
           ${item.hotel_order?.order_type === "takeaway"
            ? `
              <div>
                <div style="font-size: 12px; color: #555;">PICKUP TIME</div>
                <div style="font-size: 14px; font-weight: bold;">
                  ${item.hotel_order?.order_due_date_time ? moment(item.hotel_order.order_due_date_time).format("DD-MM-YY HH:mm A") : "ASAP"}
                </div>
              </div>
             `
            : ""
          }
           <div style="text-align:right">
              <div style="font-size: 14px; font-weight: bold;">${item.space || "N/A"}</div>
              <div style="font-size: 14px; font-weight: bold;">${item.joinedFirst3Tables || "N/A"}</div>
           </div>
      </div>
      <!-- Items List -->
      <div style="margin-top: 15px; border-top: 2px dashed #000; padding-top: 8px;">
        <table style="width: 100%; border-collapse: collapse;">
          ${item.kot_items
            .map((menuItem) => {
              const specialData = menuItem.special_data || {};
              let extraHtml = "";
              
              // VARIATION
              if (specialData.variation_data) {
                extraHtml += `
                  <tr>
                    <td colspan="2" style="padding-left: 15px; padding-bottom: 5px; font-size: 12px;">
                      <div style="font-weight: bold; margin-bottom: 2px;">VARIATION:</div>
                      <div style="margin-left: 5px;">
                        ${Object.entries(specialData.variation_data)
                          .map(([k, v]) => `• ${k}: <span style="font-weight: bold;">${v}</span>`)
                          .join("<br>")}
                      </div>
                    </td>
                  </tr>`;
              }
              
              // ADD-ONS (updated to handle array structure)
              if (specialData.add_ons_data && Array.isArray(specialData.add_ons_data)) {
                extraHtml += `
                  <tr>
                    <td colspan="2" style="padding-left: 15px; padding-bottom: 5px; font-size: 12px;">
                      <div style="font-weight: bold; margin-bottom: 2px;">ADD-ONS:</div>
                      <div style="margin-left: 5px;">
                        ${specialData.add_ons_data
                          .filter(addon => addon.is_selected === 1)
                          .map(addon => `• ${addon.option_name}`)
                          .join("<br>")}
                      </div>
                    </td>
                  </tr>`;
              }
              
              // SPECIAL REQUEST
              if (specialData.special_request) {
                extraHtml += `
                  <tr>
                    <td colspan="2" style="padding-left: 15px; padding-bottom: 10px; font-size: 12px;">
                      <div style="font-weight: bold; margin-bottom: 2px;">SPECIAL REQUEST:</div>
                      <div style="margin-left: 5px; font-style: italic;">${specialData.special_request}</div>
                    </td>
                  </tr>`;
              }
              
              return `
                <tr>
                  <td style="padding: 8px 0; font-size: 16px; font-weight: bold; vertical-align: top; width: 15%; border-bottom: 1px solid #eee;">
                    ${menuItem.item_quantity}x
                  </td>
                  <td style="padding: 8px 0; font-size: 16px; font-weight: bold; vertical-align: top; border-bottom: 1px solid #eee;">
                    ${menuItem.item_menu_name}
                    ${extraHtml}
                  </td>
                </tr>`;
            })
            .join("")}
        </table>
      </div>
      ${item.note
        ? `
        <div style="margin-top: 15px; padding: 8px; border: 1px dashed #000; font-size: 14px;">
          <div style="font-weight: bold; margin-bottom: 5px;">ORDER NOTE:</div>
          <div>${item.note}</div>
        </div>
      `
        : ""
      }
      <!-- Footer -->
      <div style="margin-top: 15px; text-align: center; font-size: 12px; color: #555; border-top: 2px solid #000; padding-top: 8px;">
        <div style="font-size: 14px; font-weight: bold;">${moment(item.created_at).format("DD-MM-YY HH:mm")}</div>
      </div>
    </div>`;
}

  handlePrintKOT = (itemId) => {
    const { kotData } = this.state
    const allItems = [...kotData.pending, ...kotData.cooking]
    const item = allItems.find((item) => item.id === itemId)

    if (!item) {
      alert("Nothing to print!")
      return
    }

    const printWindow = window.open("", "", "height=600,width=800")
    const printHtml = `
      <html>
        <head>
          <title>Print KOT</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
            body {
              font-family: 'Poppins', sans-serif;
              margin: 0;
              padding: 0;
            }
            * {
              box-sizing: border-box;
            }
          </style>
        </head>
        <body>
          ${this.createBlackAndWhiteKOT(item)}
        </body>
      </html>
    `

    printWindow.document.write(printHtml)
    printWindow.document.close()
    printWindow.focus()
    setTimeout(() => {
      printWindow.print()
      printWindow.close()
    }, 500)
  }

  renderKotPreviewModal = () => {
    const { previewOpen, currentKotItem } = this.state
    if (!previewOpen || !currentKotItem) return null

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            width: "250px",
            maxWidth: "90%",
            maxHeight: "90vh",
            overflow: "auto",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              padding: "10px",
              borderBottom: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#041A29",
              color: "#fff",
            }}
          >
            <h6 style={{ margin: 0 }}>KOT Preview</h6>
            <button
              onClick={this.closePreview}
              style={{
                background: "none",
                border: "none",
                color: "white",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
          <div style={{ padding: "15px", overflowY: "auto", backgroundColor: "#f5f5f5" }}>
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #000",
                borderRadius: "5px",
                overflow: "hidden",
                width: "100%",
                maxWidth: "58mm",
                margin: "0 auto",
                color: "#000",
                fontFamily: "monospace",
              }}
              id="kot_preview"
            >
              <div style={{ padding: "10px", borderBottom: "1px solid #000" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    flexWrap: "wrap",
                    gap: "10px",
                    borderBottom: "1px dashed #000",
                    paddingBottom: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <div>
                    <div style={{ fontSize: "10px", fontWeight: 500 }}>ORDER ID:</div>
                    <div style={{ fontSize: "16px", fontWeight: 700 }}>{currentKotItem.hotel_order_id}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: "10px", fontWeight: 500 }}>KOT NO:</div>
                    <div style={{ fontSize: "16px", fontWeight: 700 }}>{currentKotItem.id}</div>
                  </div>
                  {currentKotItem.hotel_order?.order_type === "dinein" && (
                    <div>
                      <div style={{ fontSize: "10px", fontWeight: 500 }}>Space:</div>
                      <div style={{ fontSize: "16px", fontWeight: 700 }}>{currentKotItem.space || "N/A"}</div>
                    </div>
                  )}
                  {currentKotItem.hotel_order?.order_type === "dinein" && (
                    <div>
                      <div style={{ fontSize: "10px", fontWeight: 500 }}>Table:</div>
                      <div style={{ fontSize: "16px", fontWeight: 700 }}>
                        {currentKotItem.joinedFirst3Tables || "N/A"}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px dashed #000",
                    padding: "5px 0",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      marginRight: "3px",
                      fontSize: "12px",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {currentKotItem.hotel_order?.order_type === "dinein"
                      ? "DINE-IN"
                      : currentKotItem.hotel_order?.order_type === "takeaway"
                        ? "PICK-UP"
                        : "IN-ROOM"}
                  </div>
                  <div style={{ fontSize: "12px" }}>
                    {moment(currentKotItem.created_at).format("DD-MM-YYYY / HH:mm A")}
                  </div>
                </div>
              </div>
              <div style={{ padding: "10px" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    {currentKotItem.kot_items.map((menuItem, idx) => {
                      let specialData = null
                      if (menuItem.special_data) {
                        try {
                          specialData = menuItem.special_data
                        } catch (e) {
                          console.error("Error parsing special data:", e)
                        }
                      }
                      return (
                        <React.Fragment key={idx}>
                          <tr>
                            <td style={{ fontWeight: "bold", fontSize: "14px", paddingRight: "5px" }}>
                              {menuItem.item_quantity} X
                            </td>
                            <td style={{ fontWeight: "bold", fontSize: "14px" }}>{menuItem.item_menu_name}</td>
                          </tr>
                          {specialData && specialData.variation_data && (
                            <tr>
                              <td colSpan={2} style={{ paddingLeft: "20px", fontSize: "12px", color: "#00000" }}>
                                {Object.entries(specialData.variation_data).map(([key, value]) => (
                                  <p key={key} style={{ margin: 0 }}>
                                    {key}: <b>{value}</b>
                                  </p>
                                ))}
                              </td>
                            </tr>
                          )}
                          {specialData &&
                            specialData.add_ons_data &&
                            Object.keys(specialData.add_ons_data).length > 0 && (
                              <tr>
                                <td colSpan={2} style={{ paddingLeft: "20px", fontSize: "12px", color: "#000000" }}>
                                  Add-ons:{" "}
                                  {Object.entries(specialData.add_ons_data).map(([name, price], i, arr) => (
                                    <span key={i}>
                                      {name}
                                      {i !== arr.length - 1 && ", "}
                                    </span>
                                  ))}
                                </td>
                              </tr>
                            )}
                          {specialData && specialData.special_request && (
                            <tr>
                              <td
                                colSpan={2}
                                style={{ paddingLeft: "20px", fontSize: "12px", color: "#00000", fontStyle: "italic" }}
                              >
                                Special Request: {specialData.special_request}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              {currentKotItem.note && (
                <div
                  style={{
                    paddingTop: "10px",
                    marginTop: "10px",
                    borderTop: "1px dashed #000",
                    textAlign: "center",
                    padding: "0 10px 10px",
                  }}
                >
                  Note: {currentKotItem.note}
                </div>
              )}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  fontSize: "10px",
                  padding: "0 10px 10px",
                }}
              >
                {moment().format("DD-MM-YYYY HH:mm:ss")}
              </div>
            </div>
          </div>
          <div
            style={{
              padding: "15px",
              borderTop: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#f5f5f5",
            }}
          >
            <button
              onClick={() => this.handlePrintKOT(currentKotItem.id)}
              style={{
                padding: "8px 16px",
                backgroundColor: "#041A29",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold",
                flex: "1",
                marginLeft: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i className="fa fa-print" style={{ marginRight: "8px" }}></i>
              PRINT KOT
            </button>
          </div>
        </div>
      </div>
    )
  }

  handleFullScreenChange = () => {
    const isInFullScreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement

    this.setState({
      isFullScreen: !!isInFullScreen,
    })

    if (this.pageRef.current) {
      if (isInFullScreen) {
        this.pageRef.current.classList.add("fullscreen-active")
      } else {
        this.pageRef.current.classList.remove("fullscreen-active")
      }
    }
  }

  enterFullScreen = () => {
    if (this.pageRef.current.requestFullscreen) {
      this.pageRef.current.requestFullscreen()
    } else if (this.pageRef.current.mozRequestFullScreen) {
      this.pageRef.current.mozRequestFullScreen()
    } else if (this.pageRef.current.webkitRequestFullscreen) {
      this.pageRef.current.webkitRequestFullscreen()
    } else if (this.pageRef.current.msRequestFullscreen) {
      this.pageRef.current.msRequestFullscreen()
    }
  }

  exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
  }

  renderEmptyState = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "calc(100vh - 150px)",
          width: "100%",
          padding: "20px",
        }}
      >
        <img
          src={noKotImage || "/placeholder.svg"}
          alt="No KOT Available"
          style={{
            maxWidth: "300px",
            width: "100%",
            marginBottom: "20px",
          }}
        />
        <h4>No Kitchen Orders</h4>
        <Button
          style={{ fontWeight: "bold", color: "black", backgroundColor: "#FFC857" }}
          onClick={this.handlekot}
          sx={{ marginTop: "20px" }}
        >
          Start a New KOT
        </Button>
      </Box>
    )
  }

  renderKotCard = (item, index, columnId) => {
    const status = item.status || "pending"
    const statusColors = {
      pending: { bg: "#691726", text: "white", border: "#BB0A21" },
      cooking: { bg: "#FFC857", text: "black", border: "#FFC857" },
      served: { bg: "#00A651", text: "white", border: "#00A651" },
    }
    const currentStatusColor = statusColors[status] || statusColors.pending

    // Determine button text and color based on status
    let btnValue, btnText, btnColor, textColor
    if (status === "pending") {
      btnValue = "cooking"
      btnText = "WAITING"
      btnColor = "#691726"
      textColor = "white"
    } else if (status === "cooking") {
      btnValue = "served"
      btnText = "COOKING"
      btnColor = "#FFC857"
      textColor = "black"
    } else {
      btnValue = "served"
      btnText = "SERVED"
      btnColor = "#00A651"
      textColor = "white"
    }

    return (
      <div
        key={item.id.toString()}
        className="kot-card"
        style={{
          backgroundColor: "#02111B",
          borderRadius: "12px",
          padding: columnId === "served" ? "12px" : "18px",
          borderLeft: `4px solid ${currentStatusColor.border}`,
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          position: "relative",
          overflow: "hidden",
          height: "fit-content",
          breakInside: "avoid",
          pageBreakInside: "avoid",
          display: "inline-block",
          width: "100%",
          fontSize: columnId === "served" ? "0.9em" : "1em",
          transform: columnId === "served" ? "scale(0.95)" : "none",
          transformOrigin: "top left",
          marginBottom: "16px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
          <span style={{ fontWeight: "600", color: "white" }}>Order #{item.hotel_order.order_number}</span>
          <span style={{ fontSize: "12px", color: "#9CA3AF" }}>{moment(item.created_at).fromNow()}</span>
        </div>
        <div
          style={{
            marginBottom: "8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: currentStatusColor.bg,
                color: currentStatusColor.text,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "8px",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {item.id.toString().slice(-2)}
            </div>
            <div>
              <div style={{ fontWeight: "500", color: "white" }}>KOT #{item.kot_number}</div>
              <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
                {item.hotel_order?.order_type === "dinein"
                  ? "Dine-in"
                  : item.hotel_order?.order_type === "takeaway"
                    ? "Takeaway"
                    : "In-room"}
              </div>
            </div>
          </div>
          {item.hotel_order?.order_type === "dinein" && (
            <div
              style={{
                backgroundColor: "#02111B",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                color: "white",
              }}
            >
              {item.space && <span>{item.space}</span>} |
              {item.joinedFirst3Tables && <span> {item.joinedFirst3Tables}</span>}
            </div>
          )}
        </div>
        <div
          style={{
            backgroundColor: "#02111B",
            borderRadius: "8px",
            padding: columnId === "served" ? "8px" : "12px",
            marginBottom: "12px",
          }}
        >
          <div style={{ fontSize: "13px", color: "#9CA3AF", marginBottom: "8px" }}>ITEMS</div>
          {item.kot_items.map((menuItem, idx) => {
            const specialData = menuItem.special_data || null
            return (
              <div key={idx} style={{ marginBottom: idx !== item.kot_items.length - 1 ? "10px" : "0" }}>
                <div style={{ display: "flex", color: "white" }}>
                  {status === "cooking" && (
                    <input
                      type="checkbox"
                      checked={menuItem.served_or_not === "served"}
                      // disabled={menuItem.served_or_not === "served"}
                     onChange={(e) => {
  e.stopPropagation()
  
  
  const newStatus = menuItem.served_or_not === "served" ? "not_served" : "served"
  
  // Update local state immediately for instant visual feedback
  this.setState((prevState) => {
    const newKotData = { ...prevState.kotData }
    
    // Find and update the specific item in cooking array
    const kotIndex = newKotData.cooking.findIndex((kot) => kot.id === item.id)
    if (kotIndex !== -1) {
      const itemIndex = newKotData.cooking[kotIndex].kot_items.findIndex((kotItem) => kotItem.id === menuItem.id)
      if (itemIndex !== -1) {
        newKotData.cooking[kotIndex].kot_items[itemIndex].served_or_not = newStatus
      }
    }
    
    return { kotData: newKotData }
  })
  
  // Then make the API call
  fetch(`${base_url}/kot/update_kot_item_status/${menuItem.id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ served_or_not: newStatus }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("KOT item status updated successfully to:", newStatus)
    })
    .catch((error) => {
      console.error("Error updating KOT item status:", error)
      this.showToast("Failed to update item status", "error")
      
      // Revert the local state if API call fails
      this.setState((prevState) => {
        const newKotData = { ...prevState.kotData }
        const kotIndex = newKotData.cooking.findIndex((kot) => kot.id === item.id)
        if (kotIndex !== -1) {
          const itemIndex = newKotData.cooking[kotIndex].kot_items.findIndex((kotItem) => kotItem.id === menuItem.id)
          if (itemIndex !== -1) {
            // Revert to original status
            newKotData.cooking[kotIndex].kot_items[itemIndex].served_or_not = menuItem.served_or_not === "served" ? "served" : "pending"
          }
        }
        return { kotData: newKotData }
      })
    })
}}
                      style={{
                        marginRight: "8px",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        accentColor: "#00A651",
                      }}
                      title="Mark as served"
                    />
                  )}
                  <div
                    style={{
                      color: "white",
                      borderRadius: "4px",
                      padding: "2px 6px",
                      marginRight: "8px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {menuItem.item_quantity}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div style={{ fontWeight: "500", fontSize: "14px" }}>{menuItem.item_menu_name}</div>
                      {status === "cooking" && (
                        <div style={{ display: "flex", gap: "8px" }}>
                          <button
                            onClick={(e) => {
                              e.stopPropagation()
                              this.setState({
                                isDeleteConfirmationModalOpen: true,
                                itemToDelete: menuItem.id,
                                kotItemToDelete: { kotId: item.id, menuItemId: menuItem.id },
                              })
                            }}
                            style={{
                              background: "#BB0A21",
                              border: "none",
                              color: "white",
                              cursor: "pointer",
                              fontSize: "16px",
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 0,
                              marginLeft: "8px",
                            }}
                            title="Delete item"
                          >
                            <i className="fa fa-trash" style={{ fontSize: "14px" }}></i>
                          </button>
                        </div>
                      )}
                    </div>
                    {specialData && specialData.variation_data && (
                      <div style={{ fontSize: "12px", color: "#b0bec5", marginTop: "4px" }}>
                        <span style={{ fontWeight: "500" }}>Variations: </span>
                        {Object.entries(specialData.variation_data).map(([key, value], i, arr) => (
                          <span key={key}>
                            {key}: <b>{value}</b>
                            {i !== arr.length - 1 ? ", " : ""}
                          </span>
                        ))}
                      </div>
                    )}
                    {specialData && specialData.add_ons_data && Object.keys(specialData.add_ons_data).length > 0 && (
                      <div style={{ fontSize: "12px", color: "#80cbc4", marginTop: "4px" }}>
                        <span style={{ fontWeight: "500" }}>Add-ons: </span>
                        {Object.entries(specialData.add_ons_data).map(([name, price], i, arr) => (
                          <span key={i}>
                            {name}
                            {i !== arr.length - 1 ? ", " : ""}
                          </span>
                        ))}
                      </div>
                    )}
                    {specialData && specialData.special_request && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#c5e1a5",
                          fontStyle: "italic",
                          marginTop: "4px",
                          padding: "4px 8px",
                          backgroundColor: "rgba(0,0,0,0.2)",
                          borderRadius: "4px",
                        }}
                      >
                        <span style={{ fontWeight: "500" }}>Request: </span>
                        {specialData.special_request}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "12px",
            borderTop: "1px solid #6B7280",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <span style={{ color: "white", fontSize: "14px" }}>{moment(item.created_at).format("HH:mm A")}</span>
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            {item.status === "pending" && (
              <button
                onClick={() => this.handlePrintKOT(item.id)}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#041A29",
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                <i className="fa fa-print" style={{ marginRight: "4px", color: "#FFC857" }}></i>
                Print KOT
              </button>
            )}
            {status !== "served" && (
              <button
                onClick={() => this.changeKOTStatus(item, btnValue)}
                style={{
                  padding: "6px 12px",
                  backgroundColor: btnColor,
                  color: textColor,
                  borderRadius: "4px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {btnText}
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderKanbanView = () => {
    const filteredKotData = this.getFilteredKotData()
    const columnTitles = {
      pending: "Pending Orders",
      cooking: "Cooking",
      served: "Served",
    }
    const columnColors = {
      pending: {
        headerBg: "#041A29",
        headerText: "white",
        countBg: "#691726",
        countText: "white",
      },
      cooking: {
        headerBg: "#041A29",
        headerText: "white",
        countBg: "#FFC857",
        countText: "black",
      },
      served: {
        headerBg: "#041A29",
        headerText: "white",
        countBg: "#00A651",
        countText: "white",
      },
    }

    const isEmpty =
      filteredKotData.pending.length === 0 &&
      filteredKotData.cooking.length === 0 &&
      filteredKotData.served.length === 0

    if (isEmpty) {
      return this.renderEmptyState()
    }

    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 0.5fr 0.5fr",
          gap: "24px",
          alignItems: "start",
          height: "calc(100vh - 200px)",
        }}
      >
        {Object.keys(filteredKotData).map((columnId) => {
          const columnItems = filteredKotData[columnId]
          const columnStyle = columnColors[columnId]

          return (
            <div
              key={columnId}
              style={{
                borderRadius: "12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                overflow: "hidden",
                height: "90vh",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#041A29",
              }}
            >
              <div
                style={{
                  padding: "16px",
                  backgroundColor: columnStyle.headerBg,
                  color: columnStyle.headerText,
                  borderBottom: "1px solid #6B7280",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>{columnTitles[columnId]}</h3>
                </div>
                <span
                  style={{
                    backgroundColor: columnStyle.countBg,
                    color: columnStyle.countText,
                    borderRadius: "9999px",
                    padding: "4px 10px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {columnItems.length}
                </span>
              </div>
              <div
                className={
                  columnId === "pending"
                    ? "pending-container"
                    : columnId === "cooking"
                      ? "cooking-container"
                      : "served-container"
                }
                style={{
                  padding: "20px",
                  backgroundColor: "#041A29",
                  overflowY: "auto",
                  flexGrow: 1,
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  columnCount: columnId === "pending" ? 2 : 1,
                  columnGap: "10px",
                  columnFill: "balance",
                }}
              >
                {columnItems.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "200px",
                      color: "#9CA3AF",
                      textAlign: "center",
                      columnSpan: "all",
                    }}
                  >
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.5 14H15.5M8.5 10H12M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L7.75 19L10.25 21L12.75 19L15.25 21L17.75 19L19 21Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p style={{ marginTop: "8px" }}>No orders in this category</p>
                  </div>
                ) : (
                  columnItems.map((item, index) => this.renderKotCard(item, index, columnId))
                )}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  render() {
    const { isFullScreen } = this.state

    const buttons = [
      {
        label: "Clear All",
        icon: <ClearAllIcon />,
        onClick: this.handleSmallButtonClick,
        backgroundColor: "#BB0A21",
        hoverColor: "#BB0A21",
      },
      ...(isFullScreen
        ? [
          {
            label: "Exit Full Screen",
            icon: <FullscreenExitIcon />,
            onClick: this.exitFullScreen,
            backgroundColor: "#C62828",
            hoverColor: "#C62828",
          },
        ]
        : [
          {
            label: "Enter Full Screen",
            icon: <FullscreenIcon />,
            onClick: this.enterFullScreen,
            backgroundColor: "#0D6EFD",
            hoverColor: "#0D6EFD",
          },
        ]),
      {
        label: "Refresh",
        onClick: this.fetchData,
        icon: <RefreshIcon />,
        backgroundColor: "#FFC857",
        hoverColor: "FFC857",
        color: "#000000",
      },
    ]

    return (
      <div className="container-fluid" ref={this.pageRef}>
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
        <AutoPrintKOT
          ref={this.autoPrintRef}
          showToast={this.showToast}
          fetchData={this.fetchData}
          onPrintError={this.handlePrintError}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Header title="KDS" />
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <span style={{ color: "white", fontWeight: "500" }}>Filter by:</span>
              {this.state.orderTypes.map((orderType) => (
                <button
                  key={orderType}
                  onClick={() => this.handleOrderTypeChange(orderType)}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: this.state.selectedOrderType === orderType ? "#FFC857" : "#041A29",
                    color: this.state.selectedOrderType === orderType ? "black" : "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontWeight: this.state.selectedOrderType === orderType ? "600" : "400",
                    textTransform: "uppercase",
                  }}
                >
                  {orderType === "all" ? "ALL ORDERS" : orderType}
                </button>
              ))}
            </div>
            {buttons.map((button, index) => (
              <div
                key={index}
                className="btn"
                style={{
                  marginLeft: index !== 0 ? "10px" : "0",
                  backgroundColor: button.backgroundColor,
                  color: button.color || "#ffffff",
                  fontWeight: "600",
                  display: "inline-flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={button.onClick}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = button.hoverColor)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = button.backgroundColor)}
              >
                {button.icon && <span style={{ marginRight: "8px" }}>{button.icon}</span>}
                {button.label}
              </div>
            ))}
          </div>
        </div>
        {this.renderKanbanView()}
        {this.renderKotPreviewModal()}

        {/* Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={this.state.isDeleteConfirmationModalOpen}
          onConfirm={async () => {
            try {
              await fetch(`${base_url}/kot/delete_kot_item/${this.state.itemToDelete}`, {
                method: "POST",
              })

              // Update local state without refreshing
              this.setState((prevState) => {
                const { kotId, menuItemId } = prevState.kotItemToDelete
                const updatedKotData = { ...prevState.kotData }

                // Find and update the KOT in cooking array
                const kotIndex = updatedKotData.cooking.findIndex((kot) => kot.id === kotId)
                if (kotIndex !== -1) {
                  // Remove the deleted item from kot_items
                  updatedKotData.cooking[kotIndex].kot_items = updatedKotData.cooking[kotIndex].kot_items.filter(
                    (item) => item.id !== menuItemId,
                  )

                  // If no items left, remove the entire KOT
                  if (updatedKotData.cooking[kotIndex].kot_items.length === 0) {
                    updatedKotData.cooking = updatedKotData.cooking.filter((kot) => kot.id !== kotId)
                  }
                }

                return {
                  kotData: updatedKotData,
                  isDeleteConfirmationModalOpen: false,
                  itemToDelete: null,
                  kotItemToDelete: null,
                }
              })

              this.showToast("Item deleted successfully", "success")
            } catch (error) {
              console.error("Error deleting KOT item:", error)
              this.showToast("Failed to delete item", "error")
              this.setState({
                isDeleteConfirmationModalOpen: false,
                itemToDelete: null,
                kotItemToDelete: null,
              })
            }
          }}
          onCancel={() => {
            this.setState({
              isDeleteConfirmationModalOpen: false,
              itemToDelete: null,
              kotItemToDelete: null,
            })
          }}
          title="Confirm Deletion"
          message="This action cannot be reversed."
          confirmText="Yes, delete it!"
          cancelText="Cancel"
        />

        <style>
          {`
          .kot-flex-container {
            width: 100%;
            transition: opacity 0.3s ease;
          }
          .table-responsive {
            width: 100%;
            color: white;
            border-collapse: separate;
            border-spacing: 0 8px;
            table-layout: auto;
          }
          .table-responsive td {
            padding: 3px 5px;
            vertical-align: middle;
            overflow: visible;
            word-wrap: break-word;
            word-break: break-all;
          }
          .print-icon {
            color: #FFC857;
            margin-right: 10px;
          }
          .fullscreen-active {
            animation: fadeIn 0.3s ease forwards;
          }
          @keyframes fadeIn {
            from {
              opacity: 0.9;
            }
            to {
              opacity: 1;
            }
          }
          div::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          div::-webkit-scrollbar-track {
            background: transparent;
          }
          div::-webkit-scrollbar-thumb {
            background-color: #6B7280;
            border-radius: 20px;
            border: 3px solid #02111B;
          }
          div::-webkit-scrollbar-thumb:hover {
            background-color: #4B5563;
          }
          div {
            scrollbar-width: thin;
            scrollbar-color: transparent transparent;
          }
          div:hover {
            scrollbar-color: #6B7280 transparent;
          }
          div::-webkit-scrollbar {
            display: none;
          }
          div:hover::-webkit-scrollbar {
            display: block;
          }
          @supports (scrollbar-width: thin) {
            div {
              scrollbar-width: none;
            }
            div:hover {
              scrollbar-width: thin;
            }
          }
          /* Masonry layout styles */
          .masonry-container {
            column-count: 2;
            column-gap: 20px;
            column-fill: balance;
          }
          .pending-container {
            column-count: 2 !important;
            column-gap: 20px;
          }
          @media (max-width: 768px) {
            .masonry-container, .pending-container {
              column-count: 1 !important;
            }
          }
          @media (min-width: 769px) and (max-width: 1024px) {
            .pending-container {
              column-count: 2 !important;
            }
            .cooking-container, .served-container {
              column-count: 1 !important;
            }
          }
          @media (min-width: 1025px) {
            .pending-container {
              column-count: 2 !important;
            }
            .cooking-container, .served-container {
              column-count: 1 !important;
            }
          }
          /* Optimized card styles */
          .kot-card {
            transition: box-shadow 0.2s ease;
            will-change: transform;
          }
          .kot-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.25);
          }
          /* Optimize containers for better performance */
          .pending-container,
          .cooking-container,
          .served-container {
            will-change: scroll-position;
            transform: translateZ(0);
            -webkit-overflow-scrolling: touch;
            contain: layout style;
          }
          /* Optimize rendering performance */
          .masonry-container,
          .pending-container,
          .cooking-container,
          .served-container {
            contain: layout style paint;
          }
          `}
        </style>
      </div>
    )
  }
}

export default redux(ListMenuScreen)